/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CenterNoticeChangeOrderDto } from '../../models/center-notice-change-order-dto';

export interface CenterNoticeControllerUpdateOrder$Params {
  
    /**
     * 센터 공지사항 ID와 순서
     */
    body: Array<CenterNoticeChangeOrderDto>
}

export function centerNoticeControllerUpdateOrder(http: HttpClient, rootUrl: string, params: CenterNoticeControllerUpdateOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
  const rb = new RequestBuilder(rootUrl, centerNoticeControllerUpdateOrder.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
    })
  );
}

centerNoticeControllerUpdateOrder.PATH = '/api/center-notice/center/order';
